<div class="flex flex-col h-full relative">
  @if (!isMobile) {
    <app-nav-bar></app-nav-bar>
  }
  <mat-drawer-container class="flex-1" [dir]="direction" autosize>
    <mat-drawer
      id="side-navigation"
      tabindex="-1"
      mode="side"
      opened
      [disableClose]="true"
      class="drawer drop-shadow-xl"
      [ngClass]="{
        'drawer--mobile': !!isMobile,
        'drawer--laptop': !!isLaptop,
        'drawer--desktop': !!isDesktop
      }"
      style="
      background-color: linear-gradient(
        180deg,
        rgba(0, 104, 245, 0.04) 0%,
      rgba(255, 255, 255, 0.04) 100%
      );
      "
      >
      <app-route-planning-forms-container />
    </mat-drawer>

    <mat-drawer-content>
      <!--
        a11y: on mobile the form drawer takes 100% width (drawer--mobile CSS),
        so the map landmark below is visually invisible — the user only sees
        the drawer / overlays. Audit flagged that screen reader users were
        getting announcements for map content that wasn't on screen, and that
        focus could escape the visible UI into hidden Google-Maps controls
        ("ניווט לאיזור המפה ואין נראות למפה / יש להגדיר נעילה למסך ושיהיה
        הקראה רק על מה שנראה על המסך"). Marking the main landmark `inert`
        when isMobile makes its subtree both non-focusable and aria-hidden in
        one shot, which acts as the implicit screen-lock the audit asked for.
        Desktop / laptop keep the map reachable because the drawer occupies
        only 25-35% — the map IS visible there.
      -->
      <main
        id="main-content"
        tabindex="-1"
        [attr.inert]="isMobile ? '' : null"
        [attr.aria-hidden]="isMobile ? 'true' : null"
        class="h-full w-full block m-0"
      >
        <div #mapContainer class="h-full w-full max-h-full max-w-full"></div>
      </main>
    </mat-drawer-content>
  </mat-drawer-container>

  @if ({ sid: displaySurveyId$ | async }; as surveyCtx) {
    @if (surveyCtx.sid != null) {
      <app-survey-view
        [surveyId]="surveyCtx.sid"
        (surveyClosed)="onSurveyViewClosed()"
        />
    }
  }
</div>
